module.exports = __webpack_public_path__ + "d86495746650606dec218639bbcc61fc.svg";